const mineratecProdIdentifierRegex = /^[A-Z]+-[\w\d-]+\d+$/;
const checklistIdRegex = /^[a-z]+$|^[a-z]+-[a-z\d-]+\d+$/;

export { mineratecProdIdentifierRegex, checklistIdRegex };


